import React from 'react';
import Header from '../components/Header';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import { BookOpen, Target, Eye, Lightbulb } from 'lucide-react';

const AboutCollege = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <Navigation />
      
      <div className="container mx-auto px-4 py-12">
        {/* Page Title */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-[#000066] mb-3">About College</h1>
          <div className="h-1 w-32 bg-[#FF4500] mx-auto"></div>
        </div>

        {/* Main Content */}
        <div className="max-w-5xl mx-auto space-y-8">
          
          {/* Introduction Section */}
          <div className="bg-white rounded-lg shadow-lg p-8">
            <h2 className="text-2xl font-bold text-[#000066] mb-4 flex items-center gap-2">
              <BookOpen className="w-6 h-6 text-[#FF4500]" />
              D.A.V. Velankar College of Commerce: At a Glance
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Dayanand Anglo-Vedic College Trust and Management Society, New Delhi established 
                Dayanand Institutions, Solapur in June 1940 to celebrate the victory of Satyagraha 
                launched by Arya Samaj against the atrocities and social discrepancies committed by 
                the then ruler of Hyderabad. It is one of the oldest and renowned educational 
                institutions in this part of our country.
              </p>
              <p>
                Dayanand Anglo-Vedic College Trust and Management Society, New Delhi established 
                D.A.V. Velankar College of Commerce, Solapur in June 1952. In the beginning, the 
                college was affiliated to Bombay University. However, with the establishment of Poona 
                University, it came under its jurisdiction and then it came to be affiliated to Shivaji 
                University, Kolhapur; since its inception in 1962 and since July 2004, it is affiliated 
                to Solapur University, Solapur.
              </p>
            </div>
          </div>

          {/* Infrastructure Section */}
          <div className="bg-white rounded-lg shadow-lg p-8">
            <h2 className="text-2xl font-bold text-[#000066] mb-4">Infrastructure & Facilities</h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Dayanand Institution of Solapur is spread over an area of 63 acres of land, shared by 
                other three sister concern colleges, with impressive and magnificent buildings, 
                libraries and extensive playgrounds with required amenities. The institute has an Open 
                Air Theatre for hosting cultural and other events with a sitting capacity of 7000 students.
              </p>
              <div className="grid md:grid-cols-2 gap-4 mt-6">
                <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-4 rounded-lg border-l-4 border-[#000066]">
                  <h3 className="font-semibold text-[#000066] mb-2">Academic Facilities</h3>
                  <ul className="text-sm space-y-1">
                    <li>• Spacious multi-purpose Velankar Hall</li>
                    <li>• Well equipped Air conditioned Seminar Hall</li>
                    <li>• Extensive libraries</li>
                  </ul>
                </div>
                <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-4 rounded-lg border-l-4 border-[#000066]">
                  <h3 className="font-semibold text-[#000066] mb-2">Student Amenities</h3>
                  <ul className="text-sm space-y-1">
                    <li>• Boys Hostel (370 capacity)</li>
                    <li>• Ladies Hostel (60 capacity)</li>
                    <li>• Canteen & Ladies Room</li>
                  </ul>
                </div>
                <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-4 rounded-lg border-l-4 border-[#000066]">
                  <h3 className="font-semibold text-[#000066] mb-2">Support Services</h3>
                  <ul className="text-sm space-y-1">
                    <li>• Dispensary</li>
                    <li>• Post Office</li>
                    <li>• Punjab National Bank with ATM</li>
                  </ul>
                </div>
                <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-4 rounded-lg border-l-4 border-[#000066]">
                  <h3 className="font-semibold text-[#000066] mb-2">Campus Features</h3>
                  <ul className="text-sm space-y-1">
                    <li>• 63 acres campus area</li>
                    <li>• Open Air Theatre (7000 capacity)</li>
                    <li>• Extensive playgrounds</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Vision Section */}
          <div className="bg-gradient-to-r from-[#000066] to-[#000099] rounded-lg shadow-lg p-8 text-white">
            <h2 className="text-2xl font-bold mb-4 flex items-center gap-2">
              <Eye className="w-6 h-6 text-[#FFD700]" />
              Vision
            </h2>
            <p className="text-lg leading-relaxed">
              To provide quality education to all at affordable cost with special focus on 
              economically backward and socially deprived students, creating conducive environment 
              for research and bringing everyone into the main stream of the society for brighter 
              and progressive India.
            </p>
          </div>

          {/* Mission Section */}
          <div className="bg-white rounded-lg shadow-lg p-8">
            <h2 className="text-2xl font-bold text-[#000066] mb-4 flex items-center gap-2">
              <Target className="w-6 h-6 text-[#FF4500]" />
              Mission
            </h2>
            <div className="space-y-3">
              {[
                'To create conducive environment for quality Commerce and Management education.',
                'To become a leader in promoting education for all the sections of the society from the city and mofussil area.',
                'To prepare students and the staff members for periodic assessments to provide scope for further development and also make them aware about environment, gender equality and social as well as cultural sustenance.',
                'To impart job oriented Commerce and Management education useful to the industry and society.',
                'To promote research, innovation, training and consultancy applicable and useful to the industry and society.',
                'To establish collaboration with various and relevant institutions to upgrade the knowledge and for better service to stakeholders.'
              ].map((mission, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-8 h-8 bg-[#000066] text-white rounded-full flex items-center justify-center font-bold text-sm">
                    {index + 1}
                  </div>
                  <p className="text-gray-700 pt-1">{mission}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Objectives Section */}
          <div className="bg-white rounded-lg shadow-lg p-8">
            <h2 className="text-2xl font-bold text-[#000066] mb-4 flex items-center gap-2">
              <Lightbulb className="w-6 h-6 text-[#FF4500]" />
              Objectives
            </h2>
            <div className="space-y-3">
              {[
                'To strive for excellence in teaching-learning process and all-round development of the students.',
                'To generate equal opportunities for economically backward and socially deprived students especially for girl students.',
                'To establish interaction and collaborate with industry and strengthen community network.',
                'To develop research culture among the staff and students.',
                'To create social awareness through co-curricular and extracurricular activities.'
              ].map((objective, index) => (
                <div key={index} className="flex items-start gap-3 bg-gray-50 p-4 rounded-lg hover:bg-gray-100 transition-colors">
                  <div className="flex-shrink-0 w-8 h-8 bg-[#FF4500] text-white rounded-full flex items-center justify-center font-bold text-sm">
                    {index + 1}
                  </div>
                  <p className="text-gray-700 pt-1">{objective}</p>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default AboutCollege;
